export const chartOfAccounts = {
	titlePage: "Plan de cuentas",
	tableTitle: {
		revenues: "Ingresos",
		costs: "Costos",
		expenses: "Gastos",
	},
	tableRows: {
		minimizeAll: "Minimizar",
		expandAll: "Expandir",
	},
	expandLevels: "Expandir niveles",
	categoryFixedInfo:
		"Esta categoría recibe registros automáticos del sistema y no podrá ser editada.",
	viewCode: "Mostrar código del plan de cuentas",
	usageInfo:
		"El Plan de cuentas financiero es la relación de las categorías de ingresos y gastos de una empresa. Por ser una forma de clasificar los movimientos financieros, permite organizar y entender mejor la situación financiera al observar entradas y salidas.",

	titleModal: {
		edit: "Renombrar cuenta",
		create: "Agregar cuenta",
		exclude: "Eliminar plan de cuentas",
		warning: "Este plan de cuentas tiene vínculos",
	},
	titleActions: {
		edit: "Botón de edición",
		create: "Botón de creación",
		exclude: "Botón de eliminación",
	},
	modalForm: {
		fields: {
			nameChart: {
				label: "Nombre de la cuenta",
				placeholder: "Ingrese el nombre de la cuenta",
			},
			visibility: {
				label: "Visibilidad",
				options: {
					finExManagerialReport: "DRE",
					cashflow: "Flujo de Caja",
					both: "Ambos",
				},
				tooltip:
					"La visibilidad define si la cuenta aparecerá en el DRE, Flujo de Caja o ambos informes",
			},
		},
		errors: {
			requiredField: "Campo obligatorio",
			characterLimitExceeded: "Límite de 70 caracteres excedido",
		},
		status: {
			successEdit: "Categoría editada con éxito",
			successCreate: "Categoría creada con éxito",
			successExclude: "Categoría eliminada con éxito",
		},
		content: {
			create:
				"Esta cuenta será agregada en el nivel {{level}}, código {{code}}, como subcategoría de {{typeCategory}} en la categoría {{name}}. ¿Cómo desea nombrarla?",
			edit: "¿Qué nombre desea dar a esta cuenta?",
		},
	},
	modalExcludeChart: {
		warningContent:
			"Este plan de cuentas <strong>no puede ser eliminado</strong> porque existen registros vinculados al mismo.",
		excludeContent:
			'Al confirmar la acción, eliminará permanentemente el plan de cuentas de "{{name}}". ¿Desea continuar?',
		buttonExclude: "Sí, deseo eliminar el plan",
	},
};
